const t = (r) => r.term ? typeof r.term == "string" : !1, n = (r) => r.description ? typeof r.description == "string" : !1, s = (r) => Array.isArray(r) ? r.every((e) => !(typeof e != "object" || !t(e) || !n(e))) : !1;
export {
  s as itemsValidator
};
//# sourceMappingURL=description-list-validators.js.map
